import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { useSearchParams } from "react-router-dom"

const getListDataNilai = async (
  limit?: string,
  page?: string,
  id_sys_periode?: string,
  ids_uk?: string,
  search?: string
) => {
  const params = new URLSearchParams(location.search)

  if (limit) params.set("limit", limit)
  if (page) params.set("page", page)
  if (id_sys_periode) params.set("ids_sys_periode", id_sys_periode)
  if (ids_uk) params.set("ids_uk", ids_uk)
  if (search) params.set("search", search)

  const response = await api.get(
    `/verifikator-pasca/data-rekap-nilai/index?${params.toString()}`
  )
  return response.data?.data
}

export default function VerifikatorPascaDataNilaiPage() {
  const [searchParams] = useSearchParams()

  const limitParams = searchParams.get("rowsPerPage") || ""
  const pageParams = searchParams.get("page") || ""
  const idsSysPeriodeParams = searchParams.get("ids_sys_periode") || ""
  const idSysPeriodeParams = idsSysPeriodeParams?.split("-")[0] || ""
  const idsUkParams = searchParams.get("ids_uk") || ""
  const searchQueryParams = searchParams.get("search") || ""

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataNilai",
      limitParams,
      pageParams,
      idSysPeriodeParams,
      idsUkParams,
      searchQueryParams,
    ],
    queryFn: () =>
      getListDataNilai(
        limitParams,
        pageParams,
        idSysPeriodeParams,
        idsUkParams,
        searchQueryParams
      ),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  )
}
